import { getAlgoliaIndexName } from "@tudigo-monorepo/web-tudigo-search";

type AlgoliaSortKey = "relevance" | "scheduledEndDate" | "collectedAmount";

type AlgoliaSortValue = `${string}_${
  | "relevance"
  | "scheduled_end_date_desc"
  | "total_collected_amount_desc"}`;

type AlgoliaSortOption = {
  label: string;
  value: AlgoliaSortValue;
};

const indexName = getAlgoliaIndexName();

const algoliaSortByOptions: Record<AlgoliaSortKey, AlgoliaSortOption> = {
  relevance: {
    label: "Pertinence",
    value: `${indexName}_relevance`,
  },
  scheduledEndDate: {
    label: "Date de cloture",
    value: `${indexName}_scheduled_end_date_desc`,
  },
  collectedAmount: {
    label: "Montant de la levée",
    value: `${indexName}_total_collected_amount_desc`,
  },
};

export {
  type AlgoliaSortKey,
  type AlgoliaSortValue,
  type AlgoliaSortOption,
  algoliaSortByOptions,
};
